<template>
  <div class="simple-searchable-list" style="width: 100%; height: 100%">
    <div class="d-flex justify-center">
      <SearchBar
        :color="color"
        v-model="search"
        clearable
        icon-append
        solo
        :styles="styles['searchBar']"
        :classes="classes['searchBar']"
      ></SearchBar>
    </div>
    <v-card 
      class="mt-1" 
      :flat="!showBorderList"
      :outlined="showOutlinedList"
    >
      <SimpleList
        :items="items"
        divided
        :scrollable="listHeight ? true : false"
        :disabled="listDisabled"
        :identifier-key="listIdentifierKey"
        v-on:item-click="handleItemClick"
        :filters="filters"
        :style="{'height': listHeight ? listHeight : undefined}"
        :styles="styles['simpleList']"
        :classes="classes['simpleList']"
      ></SimpleList>
    </v-card>
  </div>
</template>

<script>
import emittable from '../../mixins/emittable'
import SimpleList from '../simpleList'
// import SearchBar from './SearchBarComponent'
import SearchBar from '../searchBar'

import { VCard } from 'vuetify/lib'

export default {
  name: "SimpleSearchableListComponent",
  mixins: [emittable],
  components: {
    SimpleList,
    SearchBar,
    VCard
  },
  data: function() {
    return {
      search: undefined
    }
  },
  props: {
    items: {
      type: Array,
      default: function() {
        return []
      }
    },
    color: {
      type: String,
      default: 'primary'
    },
    searchBy: {
      type: String,
      default: 'title'
    },
    listDisabled: {
      type: Boolean,
      default: false
    },
    showBorderList: {
      type: Boolean,
      default: false
    },
    showOutlinedList: {
      type: Boolean,
      default: false
    },
    listIdentifierKey: {
      type: String,
      default: 'title'
    },
    listHeight: {
      type: String,
      default: undefined
    },
    styles: {
      type: Object,
      default: function () {
        return {
          simpleList: {},
          searchBar: {},
        };
      },
    },
    classes: {
      type: Object,
      default: function () {
        return {
          simpleList: {},
          searchBar: {},
        };
      },
    },
  },
  methods: {
    handleItemClick(item) {
      this.emit('item-click', item)
    }
  },
  computed: {
    filters: function() {
      return [{key: this.searchBy, value: this.search}]
    }
  }
} 
</script>

<style>

</style>